

export const ALLOWED_METHODS = {
  get: 'get',
  post: 'post',
} as const;

export type AllowedMethod = ValueOf<typeof ALLOWED_METHODS>;


